import { IOrganizationItem } from './organization';
import { ILegalEntityItem } from './legal-entity';
import { ICountryItem } from './entities/country';

export interface ILegalEntityFormValues {
  legal_name: string;
  tax_number: string;
  erp_id: string;
  activity?: string;
  address: string;
  dataGooglePlaces?: google.maps.places.PlaceResult;
  selectedCountry?: string;
  country?: string;
  city?: string;
}

export interface ILegalEntityFormProps {
  organization?: IOrganizationItem;
  currentLegalEntity?: ILegalEntityItem;
  countries: ICountryItem[];
  onSuccess?: (data: ILegalEntityItem) => void;
  onCancel?: VoidFunction;
}

export const DEFAULT_FORM_VALUES: Partial<ILegalEntityFormValues> = {
  legal_name: '',
  tax_number: '',
  erp_id: '',
  activity: '',
  address: '',
  dataGooglePlaces: undefined,
  selectedCountry: '',
  country: '',
  city: '',
};
